import { render, staticRenderFns } from "./EditCommunity.vue?vue&type=template&id=1e68148e&scoped=true&"
import script from "./EditCommunity.vue?vue&type=script&lang=ts&"
export * from "./EditCommunity.vue?vue&type=script&lang=ts&"
import style0 from "./EditCommunity.vue?vue&type=style&index=0&id=1e68148e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e68148e",
  null
  
)

export default component.exports